var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isApp),expression:"!isApp"}],class:[
    'public-header',
    _vm.className,
    _vm.hasBottomBorder ? 'bottom-border' : '',
    _vm.page,
    _vm.isNew ? 'is-new' : '',
    _vm.layoutVersion,
    _vm.isNewLayout ? 'new-version' : '',
    _vm.displayLayout,
    _vm.displayHorizontal ? 'horizontal' : '',
  ],style:({
    backgroundImage: `url(${_vm.headerImage})`,
    backgroundSize: '100% 100%',
    backgroundColor: _vm.backColor,
    border: '0px solid',
  })},[(_vm.iconPic)?_c('img',{staticClass:"icon-pic",attrs:{"src":_vm.iconPic}}):_vm._e(),_vm._v(" "),(_vm.showBack)?_c('span',{staticClass:"back-icon",on:{"click":_vm.back}},[_c('MBIcon',{attrs:{"name":_vm.iconName,"size":_vm.iconSize,"color":_vm.iconColor}})],1):_vm._e(),_vm._v(" "),_c('p',{class:_vm.headerTitleCls,style:({
      color: _vm.titleFontColor,
    })},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"right-icon"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }